// 車番連絡表印刷内の定数
export const 積日Bindings = ["積日", "積時間"]
export const 卸日Bindings = ["卸日", "卸時間"]

export const 積地Bindings = ["積場社名", "積場地名"]
export const 卸地Bindings = ["卸場社名", "卸場地名"]
